import {
  colors,
  maxBreakpoints,
  minBreakpoints,
} from '@noths/polaris-client-ribbons-design-system';
import {
  fontSize,
  mediaQuery,
  primaryRegularFont,
  primarySemiBoldFont,
  pxToRem,
  stack,
  theme,
} from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { fonts, text, spacing, designSystemFontSizes } = theme;

export const skeletonWrapper = css`
  display: grid;
  grid-template-columns: ${pxToRem(205)} ${pxToRem(94)};
  justify-content: space-between;
  align-items: center;
  column-gap: ${pxToRem(spacing.sm)};
  margin: ${stack(spacing.sm)};
`;

export const skeletonTooltipWrapper = css`
  display: grid;
  grid-template-columns: 1fr ${pxToRem(16)};
`;

export const deliveryEventWrapper = css`
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  margin: ${stack(spacing.sm)};
`;

export const labelWrapper = css`
  height: fit-content;
  padding: 0 ${pxToRem(spacing.xs + 2)};
  border-radius: ${pxToRem(6)};
  background-color: ${colors.neutralLighter};
`;

export const label = css`
  margin: 0;
  text-align: center;
  color: ${colors.functionalGreenPrimary};
  ${fontSize(text.xxs.SMALL)}
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
`;

export const tooltipLabel = css`
  display: grid;
  grid-template-columns: 1fr ${pxToRem(16)};
  place-items: center;
  ${fontSize(text.xxs.SMALL)}

  ${mediaQuery(
    { min: minBreakpoints.L, max: maxBreakpoints.L },
    css`
      grid-template-columns: min-content auto;
    `,
  )};
`;

export const tooltipIcon = css`
  display: inline-block;
  margin-left: ${pxToRem(spacing.base)};
`;

export const tooltipContentWrapper = css`
  width: ${pxToRem(254)} !important;
  padding: ${pxToRem(spacing.lg)} !important;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      width: ${pxToRem(330)} !important;
      padding: ${pxToRem(spacing.md)} !important;
    `,
  )};
`;

export const deliveryOptionsList = css`
  list-style: none;
  padding-left: 0;
  margin: 0;
`;

export const deliveryOption = css`
  margin: 0 0 ${pxToRem(spacing.sm)};

  &:last-child {
    margin: 0;
  }
`;

export const deliveryType = css`
  margin: 0;
  ${primaryRegularFont}
  ${fontSize(designSystemFontSizes.BODY.XS)}
`;

export const dateAndPriceWrapper = css`
  display: flex;
  justify-content: space-between;
  column-gap: ${pxToRem(spacing.sm)};
  ${primarySemiBoldFont}
`;

export const dateAndPriceAndLateDeliveryWrapper = css`
  display: grid;
  grid-template-columns: 1fr;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      grid-auto-flow: column;
    `,
  )};
`;

export const dateAndPrice = css`
  margin: 0;
  ${fontSize(designSystemFontSizes.BODY.XS)}
`;

export const lateDelivery = css`
  ${dateAndPrice};
  color: ${colors.functionalRedPrimary};

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      margin-left: ${pxToRem(spacing.base)};
    `,
  )};
`;
